import { Component } from '@angular/core';
import { LoginDto } from '@api/auth/interfaces';
import { NzModalRef } from 'ng-zorro-antd/modal';

function isPropertySet<T extends Record<PropertyKey, unknown>, K extends keyof T>(obj: T, property: K):
	obj is T & Record<K, NonNullable<T[K]>> {
	return obj[property] !== undefined;
}

@Component({
	selector: 'app-login-dialog',
	templateUrl: './login-dialog.component.html',
	styleUrls: ['./login-dialog.component.scss'],
})
export class LoginDialogComponent {
	public forceCurrentUser = true;
	
	public result: Partial<LoginDto> = {};
	
	constructor(private readonly modalRef: NzModalRef<LoginDialogComponent, LoginDto>) {}
	
	public cancel(): void {
		void this.modalRef.close();
	}
	
	public confirm(): void {
		const result = this.result;
		if (
			isPropertySet(result, 'username') &&
			isPropertySet(result, 'password')
		) {
			void this.modalRef.close(result);
		}
	}
}
